import React, { useState } from "react";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Banner, Toast, Tooltip } from "@shopify/polaris";
import {
  ckeditorConfig,
  reqGetOptimizeProductDescription,
} from "../../../../../../api";
import intl from "../../../../../../i18n/intl";
import { store } from "../../../../../../store";
import { changeBannerData } from "../../../../../../slice";
/**
 *
 * @param {Object} data 商品详情
 * @param {Function} setRuleForm 修改商品详情方法
 * @param {onSave} onSave 保存
 * @returns
 */
const Description = ({
  id,
  data,
  setRuleForm,
  onSave,
  setChatData,
  chatData,
}) => {
  const handleChange = (datas) => {
    setRuleForm((preState) => {
      let currentData = preState?.Description ? preState?.Description : "";
      let param = { ...currentData, Description: datas };
      const params = { ...preState, Description: param };
      return params;
    });
  };
  // ai优化产品标题
  const [chatLoading, setChatLoading] = useState(false);
  const handleChatDsc = async () => {
    try {
      let params = {
        user_product_id: id,
      };
      if (chatData.chatAction) {
        store.dispatch(changeBannerData({bannerData:{
          show:true,
          desc:intl.get('Prior task in progress,please wait.')
        }}));
        return;
      }
      setChatData((prevValue) => ({
        ...prevValue,
        dscModal: true,
        chatAction: true,
      }));
      setChatLoading(true);
      let res = await reqGetOptimizeProductDescription(params);
      if (res.code === "200") {
        setChatData((prevValue) => ({
          ...prevValue,
          user_product_id: id,
          chatAction: false,
          dscOpen: true,
          dscFc: handleChange,
          oldDsc: data?.Description,
          dsc: res.data.optimized_description,
        }));
        toggleToast(intl.get('Optimization completed'))
        setShowToast2(false);
      } else {
        store.dispatch(changeBannerData({bannerData:{
          show:true,
          desc:res.msg
        }}));
      }
      setChatLoading(false);
    } catch (error) {}
  };
  const handleCancel = () => {
    setChatData((prevValue) => ({
      ...prevValue,
      dscOpen: false,
      dscModal: false,
      chatAction: false,
    }));
    setShowToastText("");
    setShowToast(false);
    setShowToast2(false);
    setChatLoading(false);
  };
  const [showToast, setShowToast] = useState(false);
  const [showToast2, setShowToast2] = useState(false);
  const [showToastText, setShowToastText] = useState("");
  const [showToastIserror, setShowToastIserror] = useState(false);
  //提示弹窗
  const toggleToast = (showToastText, showToastIserror = false) => {
    setShowToast(!showToast);
    setShowToastText(showToastText);
    setShowToastIserror(showToastIserror);
  };
  const toggleToast2 = (showToastText, showToastIserror = false) => {
    setShowToast(false);
    setShowToastText(showToastText);
    setShowToastIserror(showToastIserror);
  };
  const toastMarkup =
    showToast && chatData.dscModal && showToastText !== "" ? (
      <Toast
        content={showToastText}
        onDismiss={() => toggleToast("")}
        error={showToastIserror}
        duration={1500}
      />
    ) : null;
  const toastMarkup2 =
    showToast2 && showToastText !== "" ? (
      <Toast
        content={showToastText}
        onDismiss={() => toggleToast2("")}
        error={showToastIserror}
        duration={1500}
      />
    ) : null;
  return (
    <div>
      <div
        className="mb-6"
        style={{
          marginBottom: "1.5rem",
          display: data.status ? "none" : "block",
        }}
      >
        <Banner tone="info">
          <p>
            {intl.get("After input, click the blank area to save the data.")}
          </p>
        </Banner>
      </div>
      {!data.status && (
        <div className="chat_gpt_title">
          {!chatLoading ? (
            <div
              className="chat_gpt_button_list"
              onClick={() => handleChatDsc()}
            >
              <div className="chat_gpt_button_list_img">
                <img width={20} src="/chatgpt_base.png" alt="dropshipman" />
              </div>
              <div style={{ margin: "0 5px" }}>{intl.get("AI Description Optimization")}</div>
            </div>
          ) : (
            <div
              className="chat_gpt_button_list"
              onClick={() => handleCancel()}
            >
              <div className="chat_gpt_button_list_img chat_gpt_button_list_imgs">
                <img width={20} src="/chatgpt_loading.png" alt="dropshipman" />
              </div>
              <div style={{ margin: "0 5px" }}>
                <Tooltip content="Stop optimization.">
                  <span>{intl.get("Optimizing...")}</span>
                </Tooltip>
              </div>
              <img width={20} src="/chatgpt_stop.png" alt="dropshipman" />
            </div>
          )}
        </div>
      )}
      <CKEditor
        editor={ClassicEditor}
        config={ckeditorConfig}
        data={data?.Description ? data?.Description : ""}
        disabled={data.status}
        onChange={(event, editor) => {
          const datas = editor.getData();
          handleChange(datas);
        }}
        onBlur={() => {
          onSave("description");
        }}
      />
      {toastMarkup}
      {toastMarkup2}
    </div>
  );
};

export default Description;
